export default __webpack_public_path__ + "static/media/Pilgrim's Wraps of the Three Clarities.44eebd34.jpg";